var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#292424",
  fillRule: "evenodd",
  d: "M9.599 17.387a.657.657 0 0 0 .994-.001l3.76-4.359a1 1 0 0 0 0-1.306l-3.68-4.266a.762.762 0 1 0-1.154.997l3.115 3.595a.5.5 0 0 1 0 .654l-3.035 3.503a.9.9 0 0 0 0 1.183",
  clipRule: "evenodd"
})));
export default SvgNewArrow;